import React, { useEffect, useState } from 'react';
import TrainingService from '../../Service/TrainingService';

const TrainingMethod = ({ training }) => {
    const [editMode, setEditMode] = useState(false);
    const [method, setMethod] = useState('');
    const token = sessionStorage.getItem('token');

    // Initialiser la méthode avec le contenu HTML
    useEffect(() => {
        if (training.methode) {
            setMethod(training.methode); // Conserver le contenu HTML existant
        } else {
            setMethod('Cette formation alterne la théorie et la pratique'); // Placeholder par défaut
        }
    }, [training.methode]);

    // Gérer le changement de texte
    const handleMethodChange = (event) => {
        setMethod(event.target.value); // Mettre à jour le texte brut
    };

    const handleEditClick = () => {
        setEditMode(true);
    };

    // Sauvegarder les modifications
    const handleSaveClick = async () => {
        // Convertir les retours à la ligne en balises HTML avant d'enregistrer
        const formattedMethod = method.replace(/\n/g, '<br>');
        training.methode = formattedMethod;

        try {
            let response;
            if (training.modif) {
                response = await TrainingService.putModifTraining(training);
            } else {
                response = await TrainingService.postModifTraining(training);
            }
            window.location.reload();
            console.log(response);
        } catch (error) {
            console.error("Error:", error);
        }
        setEditMode(false); // Quitter le mode d'édition
    };

    return (
        <div className="section-content">
            {editMode ? (
                <div>
                    {/* Mode édition : Textarea */}
                    <label>Méthode de la formation :</label>
                    <textarea
                        value={method}
                        onChange={handleMethodChange}
                        rows={3}
                        style={{ width: '100%' }}
                    />
                </div>
            ) : (
                // Mode affichage : Contenu HTML
                <div
                    dangerouslySetInnerHTML={{
                        __html: method, // Affiche le contenu avec les balises <br>
                    }}
                ></div>
            )}
            {editMode ? (
                <button
                    className="inscription-button modif_button"
                    onClick={handleSaveClick}
                    style={{ right: 0 }}
                >
                    Enregistrer
                </button>
            ) : (
                token === '' && (
                    <button
                        className="inscription-button modif_button"
                        onClick={handleEditClick}
                        style={{ marginLeft: '10px' }}
                    >
                        Modifier
                    </button>
                )
            )}
        </div>
    );
};

export default TrainingMethod;